export const convertToResourceKeyFromPath = (path: string) => path.replace(/^https?:\/\//gi, '');
